import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { copyToClipboard, setLocalStorageData } from "lib/utils";
import styles from "./CustomerList.module.scss";
import { Tooltip } from "@mui/material";
import LoadingScreen from "component/LoadingScreen";
import { REACT_APP_FITVIEW_URL, ROUTES, SELECTED_STORE } from "lib/Constants";
import CustomButton from "atoms/customButton/CustomButton";
import NoDataPlaceHolder from "component/NoDataPlaceHolder";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store/store";
import { CUSTOMER_LIST } from "store/customer/action.types";
import { setCustomerSearchList, setSelectedStore } from "store/customer/reducer";
import CustomDialog from "component/CustomDialog";
import Register from "component/Register";
import { CopyAll } from "@mui/icons-material";

const CustomerList = () => {
	const { loading, selectedTenant } = useSelector((store: RootState) => store.auth);
	const { customerList, customerSearchList, listLoading, selectedStore } = useSelector((store: RootState) => store.customer);
	const navigate = useNavigate();
	const [buttonLoading] = useState<boolean>(false);
	const [searchStore, setSearchStore] = useState<string>("");
	const dispatch = useDispatch();
	const [showModal, setShowModal] = useState<boolean>(false);
	const [storeUrl, setStoreUrl] = useState<string>("");
	const [preDetails, setPreDetails] = useState<any>();

	const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setSearchStore(value);
		if (value) {
			const filteredList = customerList?.filter((el: Record<string, string>) => el.name.toLowerCase().includes(value.toLowerCase()));
			dispatch(setCustomerSearchList(filteredList));
		} else {
			dispatch(setCustomerSearchList(customerList));
		}
	};
console.log(selectedTenant,"selectedTenant");

	const handleShowModal = (url = "", data?: any) => {
		if (typeof url === "string") {
			setStoreUrl(url);
		}
		setPreDetails(data);
		setShowModal(!showModal);
	};
	const handleSelectedStore = (store: any) => {
		dispatch(setSelectedStore({ ...store, count: customerList?.length }));
		setLocalStorageData(SELECTED_STORE, { ...store, count: customerList?.length });
	};
	useEffect(() => {
		if (selectedTenant) {
			dispatch({ type: CUSTOMER_LIST, payload: selectedTenant?.tenantId });
		}
		return () => {
			dispatch(setCustomerSearchList([]));
		}
	}, []);
	useEffect(() => {
		if (customerList?.length === 1 && selectedTenant?.isInternal) {
			handleSelectedStore(customerList?.[0]);
			navigate(ROUTES.HOME);
		}
		
	}, [customerList]);

	return listLoading || loading ? (
		<div className="flex-wrap align-center justify-center w-full h-full">
			<LoadingScreen height={false} customClass="h-full" />
		</div>
	) : (
		<div className={` ${styles.list} flex flex-column justify-between`}>
			<>
				<div className={` ${styles.list__form} flex-wrap gap-10 justify-end`}>
					<div className={` ${styles.list__formBtn} flex gap-10 align-center`}>
						<input placeholder="Search store.." type="text" value={searchStore} onChange={handleOnChange} />
						<CustomButton buttonText="Register" className="button" handleFunc={handleShowModal} />
					</div>
				</div>{" "}
				<div className={` ${styles.list__outer}`}>
					<div className={` ${styles.list__wrapMain} flex`}>
						<div className={` ${styles.list__wrap} flex`}>
							{customerSearchList && customerSearchList?.length > 0 ? (
								customerSearchList?.map((el: Record<string, any>) => (
									<div
										role={"button"}
										className={` ${styles.list__item} `}
										key={el?.customerId}
										onClick={() => {
											handleSelectedStore(el);
										}}
									>
										<aside className={el?.customerId === selectedStore?.customerId ? styles.active : ""}>
											<h2>
												<span>{el?.name}</span>
											</h2>
											<span className={` ${styles.storeUrl}`}>{el?.storeUrl}</span>
											<div className="flex gap-10">{el?.isTrialDemo && <p className={` ${styles.appNotInstalled} ${styles.green}`}>Demo</p>}</div>
											{el?.isTrialDemo && el?.hasCustomAddon && (
												<Tooltip title={`${REACT_APP_FITVIEW_URL}/custom/${el?.storeUrl}`} placement="bottom-start">
													<p className={` ${styles.appNotInstalled} ${styles.blue}`}>
														<CopyAll />
														<span
															id={`copy-store-url${el?.storeUrl}`}
															onClick={() => copyToClipboard(`${REACT_APP_FITVIEW_URL}/custom/${el?.storeUrl}`, `copy-store-url${el?.storeUrl}`, "Copied", "Copy store url")}
														>
															Copy store url
														</span>
													</p>
												</Tooltip>
											)}
										</aside>
									</div>
								))
							) : (
								<div className="flex-wrap align-center justify-center w-full">
									<NoDataPlaceHolder message="No store found in this list" />
								</div>
							)}
						</div>
					</div>
					<div className={`${styles.list__button} flex-wrap justify-end`}>
						<CustomButton buttonText={"Next"} className="button" handleFunc={() => navigate(ROUTES.HOME)} disabled={buttonLoading || !Object.keys(selectedStore)?.length} loading={buttonLoading} />
					</div>
				</div>
			</>
			{/* ) : ( */}
			{/* <div className="flex-wrap align-center justify-center w-full">
					<NoDataPlaceHolder message="No store found in this list" />
				</div> */}
			{/* )} */}
			<CustomDialog className="registerModal disabled-overlay" open={showModal} handleShowModal={handleShowModal}>
				<Register
					registerSuccess={() => dispatch({ type: CUSTOMER_LIST, payload: selectedTenant?.tenantId })}
					handleShowModal={handleShowModal}
					showClose
					selectedStoreUrl={storeUrl}
					preDetails={preDetails}
					tenantId={selectedTenant?.tenantId}
				/>
			</CustomDialog>
		</div>
	);
};

export default CustomerList;
